import { render, staticRenderFns } from "./ListLocations.vue?vue&type=template&id=4356e458&scoped=true&"
import script from "./ListLocations.vue?vue&type=script&lang=js&"
export * from "./ListLocations.vue?vue&type=script&lang=js&"
import style0 from "./ListLocations.vue?vue&type=style&index=0&id=4356e458&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4356e458",
  null
  
)

export default component.exports